const SAP_POST_LOGIN_REDIRECT_KEY = "sap_post_login_redirect"

export const setSapPostLoginRedirect = (path: string) => {
  const normalizedPath = String(path || "").trim()

  if (!normalizedPath) {
    return
  }

  window.sessionStorage.setItem(SAP_POST_LOGIN_REDIRECT_KEY, normalizedPath)
}

export const getSapPostLoginRedirect = (): string | null => {
  const storedPath = window.sessionStorage.getItem(SAP_POST_LOGIN_REDIRECT_KEY)
  return storedPath ? storedPath : null
}

export const consumeSapPostLoginRedirect = (): string | null => {
  const storedPath = getSapPostLoginRedirect()

  if (storedPath) {
    window.sessionStorage.removeItem(SAP_POST_LOGIN_REDIRECT_KEY)
  }

  return storedPath
}
